import { render, staticRenderFns } from "./DirectoriesList.vue?vue&type=template&id=98b9ccba&"
import script from "./DirectoriesList.vue?vue&type=script&lang=js&"
export * from "./DirectoriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DirectoriesList.vue"
export default component.exports